import { CloseOutlined } from "@ant-design/icons";
import { Button, Drawer, Form, Input, Select } from "antd";
import React from "react";

const { Option } = Select;

const EmailReportDrawer = ({ visible, onClose, getEmailReports }) => {
  const [form] = Form.useForm();

  const applyFilter = () => {
    const values = form.getFieldsValue();
    getEmailReports(values);
    // onApplyFilters?.(filters);
    onClose();
  };
  const clearFilters = () => {
    form.resetFields();
    // onClose();
  };
  return (
    <Drawer
      title={
        <div className="flex items-center justify-between p-2">
          <span className="text-[18px] font-bold text-[#0b1c4d]">
            Email Report Filters
          </span>

          <div
            onClick={onClose}
            className="w-[30px] h-[30px] flex items-center justify-center rounded-lg bg-[#eef2ff] cursor-pointer hover:bg-[#e0e7ff]"
          >
            <CloseOutlined className="text-[#0b1c4d] text-[18px]" />
          </div>
        </div>
      }
      placement="right"
      open={visible}
      onClose={onClose}
      closable={false}
      width={400}
      bodyStyle={{ padding: "20px" }}
      footer={
        <div className="flex justify-between">
          <Button onClick={clearFilters}>Clear All</Button>
          <Button type="primary" onClick={applyFilter}>
            Apply Filters
          </Button>
        </div>
      }
    >
      <Form layout="vertical" form={form}>
        <Form.Item label="Account ID" name="accountId">
          <Input placeholder="Enter Account ID" />
        </Form.Item>

        <Form.Item label="Status" name="status">
          <Select placeholder="Select Status" allowClear>
            <Option value="Sent">Sent</Option>
            <Option value="Delivered">Delivered</Option>
            <Option value="Failed">Failed</Option>
          </Select>
        </Form.Item>

        <Form.Item label="Email Type" name="emailType">
          <Select placeholder="Select Email Type" allowClear>
            <Option value="GPR_UPDATED_SMS">GPR UPDATED SMS</Option>
            <Option value="PERFORMANCE">PERFORMANCE</Option>
            <Option value="COGS_Notifications">COGS Notifications</Option>
          </Select>
        </Form.Item>
        <Form.Item label="Subject" name="Subject">
          <Select placeholder="Select Subject" allowClear>
            <Option value="AAPA Compliance Metrics: Weekly Update">
              AAPA Compliance Metrics: Weekly Update
            </Option>
            <Option value="AAPA Monthly GPR">AAPA Monthly GPR</Option>
            <Option value="QTD Preliminary COGs Report Used for Forecasting Only">
              QTD Preliminary COGs Report Used for Forecasting Only
            </Option>{" "}
          </Select>
        </Form.Item>

        <Form.Item label="Engagement Status" name="engagementStatus">
          <Select placeholder="Select Engagement Status" allowClear>
            <Option value="click">Click</Option>
            <Option value="view">View</Option>
          </Select>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default EmailReportDrawer;

// import { CloseOutlined } from '@ant-design/icons'
// import { Button, Drawer } from 'antd'
// import React from 'react'

// const EmailReportDrawer = ({visible,onClose}) => {
//   return (
//         <>
//       <Drawer
//         title={
//           <div className="flex items-center justify-between p-2 border-none">
//             <span className="text-[18px] font-bold text-[#0b1c4d]">
//               Email Report Filters
//             </span>
//             <div
//               onClick={onClose}
//               className="w-[30px] h-[30px] flex items-center justify-center rounded-lg bg-[#eef2ff] cursor-pointer hover:bg-[#e0e7ff]"
//             >
//               <CloseOutlined className="text-[#0b1c4d] text-[18px]" />
//             </div>
//           </div>
//         }
//         placement="right"
//         onClose={onClose}
//         closable={false}
//         open={visible}
//         width={400}
//         bodyStyle={{ padding: 0 }}
//         footer={
//           <div className="flex justify-between">
//             <Button >Clear All</Button>
//             <Button type="primary" >Apply Filters</Button>
//           </div>
//         }
//       >

//       </Drawer>
//       </>
//   )
// }

// export default EmailReportDrawer
